module.exports = __webpack_public_path__ + "img/ikd.2bac3db5.png";